
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skinTopics",
      function () {
        return require("private-next-pages/skinTopics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skinTopics"])
      });
    }
  